import { render, staticRenderFns } from "./IlpaNextEvents.vue?vue&type=template&id=3fe0de15"
import script from "./IlpaNextEvents.vue?vue&type=script&lang=js"
export * from "./IlpaNextEvents.vue?vue&type=script&lang=js"
import style0 from "./IlpaNextEvents.vue?vue&type=style&index=0&id=3fe0de15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports